/**
 * Removes items from the passed array of objects with a property mathing the passed value
 * @param {Array<Object>} target The array of objects to filter
 * @param {String} propertyName The name of the property to check
 * @param {Number|String} propertyValue The matching value to remove
 */
export const filterByProperty = (target = [], propertyName = '', propertyValue) =>
  target.filter((item = {}) => item[propertyName] !== propertyValue);
